import { IEntity } from '../interfaces/entity';
import { SubjectType } from './subject-type';
import { User } from './user';
import { Subject } from './subject';

export interface IUserSubjectHistoryList{
  items: UserSubjectHistory[];
  totalCount: number;
}

export class UserSubjectHistory implements IEntity {
  id: number;
  uid: string;
  userId: number;
  user: User;
  subjectId: number;
  subject: Subject;
  subjectTypeId: number;
  subjectType: SubjectType;
  dateCreated: string;
  primaryLink: string;

  constructor(userSubjectHistory?){
    userSubjectHistory = userSubjectHistory || {};
    this.id = userSubjectHistory.id;
    this.uid = userSubjectHistory.uid;
    this.userId = userSubjectHistory.userId;
    this.user = userSubjectHistory.user;
    this.subjectId = userSubjectHistory.subjectId;
    this.subject = userSubjectHistory.subject;
    this.subjectTypeId = userSubjectHistory.subjectTypeId;
    this.subjectType = userSubjectHistory.subjectType;
    this.dateCreated = userSubjectHistory.dateCreated || '';
    this.primaryLink = userSubjectHistory.primaryLink || '';
  }
}
